import React, { useEffect, useRef } from 'react';
export const ModalActionButtons = ({ updateModalResource, currentModalResource, prevModalResource, nextModalResource, modalList }) => {
    const focusRef = useRef(null);
    useEffect(() => {
        if (focusRef === null || focusRef === void 0 ? void 0 : focusRef.current)
            focusRef.current.focus();
    }, []);
    const onKeyDown = (event) => {
        const keyCode = event.keyCode || event.key;
        switch (keyCode) {
            case 37 || 'ArrowLeft':
                (prevModalResource) && onNavigatePrev();
                break;
            case 39 || 'ArrowRight':
                (nextModalResource) && onNavigateNext();
                break;
        }
    };
    const onClickDot = (index) => {
        updateModalResource(modalList[index]);
    };
    const onNavigatePrev = () => {
        updateModalResource(prevModalResource);
    };
    const onNavigateNext = () => {
        updateModalResource(nextModalResource);
    };
    return (React.createElement("div", { ref: focusRef, onKeyDown: onKeyDown, tabIndex: 0, className: "EventModal__pagination" }, (prevModalResource || nextModalResource) && (React.createElement(React.Fragment, null,
        Boolean(modalList.length) &&
            React.createElement("div", { className: "EventModal__dotContainer" },
                React.createElement("div", { className: "sr-only" }, "Item "),
                modalList.map((uid, index) => (React.createElement("div", { key: uid, className: `EventModal__dot${currentModalResource == uid ? ' current' : ''}${modalList.length > 20 ? ' small' : ''}`, onClick: () => { onClickDot(index); } }, index + 1))),
                React.createElement("div", { className: "sr-only" },
                    " of ",
                    modalList.length + 1)),
        React.createElement("div", { className: "EventModal__buttonContainer" },
            React.createElement("div", { className: `EventModal__prevButtonContainer${(!prevModalResource) ? ' EventModal__prevButtonContainer--disabled' : ''}` },
                React.createElement("button", { className: 'Button Button--arrowLeft EventModal__prevButton', disabled: (!prevModalResource), onClick: onNavigatePrev },
                    React.createElement("span", { className: 'EventModal__prevButtonLabel sr-only' }, "Previous"),
                    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" },
                        React.createElement("path", { d: "m201.37 438.63-160-160a32 32 0 0 1 0-45.26l160-160a32 32 0 0 1 45.26 45.26L141.25 224H448a32 32 0 0 1 0 64H141.25l105.38 105.37c6.25 6.25 9.37 14.44 9.37 22.63s-3.12 16.38-9.37 22.63a32 32 0 0 1-45.26 0z" })))),
            React.createElement("div", { className: `EventModal__nextButtonContainer${(!nextModalResource) ? ' EventModal__nextButtonContainer--disabled' : ''}` },
                React.createElement("button", { className: 'Button Button--arrowRight EventModal__nextButton', disabled: (!nextModalResource), onClick: onNavigateNext },
                    React.createElement("span", { className: 'EventModal__nextButtonLabel sr-only' }, "Next"),
                    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" },
                        React.createElement("path", { d: "m310.63 438.63 160-160a32 32 0 0 0 0-45.26l-160-160a32 32 0 0 0-45.26 45.26L370.75 224H64a32 32 0 0 0 0 64h306.75L265.37 393.37c-6.25 6.25-9.37 14.44-9.37 22.63s3.12 16.38 9.37 22.63a32 32 0 0 0 45.26 0z" })))))))));
};
